import { createGlobalStyle, css } from "styled-components";

import { fontFamily } from "./grid";

const BorderUtils = css`
  .border {
    &-top-0 {
      border-top: 0;
    }

    &-right-0 {
      border-right: 0;
    }

    &-bottom-0 {
      border-bottom: 0;
    }

    &-left-0 {
      border-left: 0;
    }
  }
`;

const PaddingUtils = css`
  .p {
    &r-1 {
      padding-right: 0.25rem;
    }

    &l-1 {
      padding-left: 0.25rem;
    }
  }
`;

export const BootstrapButtonOverrides = css`
  .btn-primary {
    --bs-btn-color: #fff;
    --bs-btn-bg: rgba(111, 66, 193, 1);
    --bs-btn-border-color: rgba(111, 66, 193, 1);
    --bs-btn-hover-color: #fff;
    --bs-btn-hover-bg: rgba(100, 50, 150, 1);
    --bs-btn-hover-border-color: rgba(111, 66, 193, 1);
    --bs-btn-focus-shadow-rgb: 49, 132, 253;
    --bs-btn-active-color: #fff;
    --bs-btn-active-bg: rgba(111, 66, 193, 1);
    --bs-btn-active-border-color: rgba(111, 66, 193, 1);
    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
    --bs-btn-disabled-color: #fff;
    --bs-btn-disabled-bg: rgba(111, 66, 193, 1);
    --bs-btn-disabled-border-color: rgba(111, 66, 193, 1);
  }
  /*
  .btn-secondary {
    --bs-btn-color: #fff;
    --bs-btn-bg: rgba(234, 232, 228, 1);
    --bs-btn-border-color: rgba(234, 232, 228, 1);
    --bs-btn-hover-color: #fff;
    --bs-btn-hover-bg: #5c636a;
    --bs-btn-hover-border-color: #565e64;
    --bs-btn-focus-shadow-rgb: 130, 138, 145;
    --bs-btn-active-color: #fff;
    --bs-btn-active-bg: #565e64;
    --bs-btn-active-border-color: #51585e;
    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
    --bs-btn-disabled-color: #fff;
    --bs-btn-disabled-bg: rgba(234, 232, 228, 1);
    --bs-btn-disabled-border-color: rgba(234, 232, 228, 1);
  }
*/
`;

const BootstrapBadgeOverrides = css`
  /* TODO: fix TopMenu notification pill
  .badge {
    font:
      400 13px/13px ${fontFamily},
      "Segoe UI",
      sans-serif;
    padding: 0.75rem 0.5rem;
    white-space: initial;
  }
*/
`;

const ModalOverrides = css`
  body > .fade {
    z-index: 10;
  }

  .modal {
    --bs-modal-padding: 2rem;
  }
  .modal-title {
    font:
      600 1.5rem/1 ${fontFamily},
      "Segoe UI",
      sans-serif;
    color: rgba(0, 58, 120, 1);
  }
  .modal-footer {
    padding: 1rem 1.5rem;
  }
`;

const BreadCrumbsOverrides = css`
  .breadcrumb {
    margin: 0;
  }
`;

const AgGridOverrides = css`
  .ag-theme-material .ag-cell-inline-editing,
  .ag-theme-material-auto-dark .ag-cell-inline-editing,
  .ag-theme-material-dark .ag-cell-inline-editing {
    padding: 0;
    height: 100%;
  }

  .ag-event-mapping {
    .ag-cell,
    .ag-header-cell,
    .ag-header-group-cell {
      padding-left: 0.5rem;
      padding-right: 0.5rem;
    }
  }
`;

export const GlobalStyles = createGlobalStyle`
  ${BorderUtils}
  ${PaddingUtils}
  ${BootstrapButtonOverrides}
  ${BootstrapBadgeOverrides}
  ${ModalOverrides}
  ${BreadCrumbsOverrides}
  ${AgGridOverrides}
`;
